const initialState = () => ({
  countries: [],
});

const state = initialState();

export default state;
